module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lisa Ann Scott\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("LISA ANN SCOTT ")]), _vm._v("is the author of the "), _c('I', [_vm._v("L’école des poneys enchantés")]), _vm._v(" and the "), _c('I', [_vm._v("La fée des souhaits")]), _vm._v(" series, and "), _c('I', [_vm._v("School of Charm")]), _vm._v(". She has been a TV news producer, reporter, and anchor, and she currently works as a voice-over artist. She lives in upstate New York.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZaLVKe/tc-custom/9780545908986.jpg?1709177418912",
      "alt": "This image is the cover for the book Dreams That Sparkle, Enchanted Pony Academy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dreams That Sparkle, Enchanted Pony Academy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this fantasy tale, the most beautiful student at the Enchanted Pony Academy hopes to prove she’s more than just her looks.")]), _c('br'), _c('br'), _vm._v("Belissima is the prettiest pony at the Enchanted Pony Academy—everyone says so. The problem is, no one seems to see what else Belissima is: talented and hardworking. She dreams that someday everyone will see that her real magic doesn’t have anything to do with her looks!"), _c('br'), _c('br'), _vm._v("The royal children are coming to the Academy for the selection ceremony, and Belissima is determined to show that she’s not just a pretty pony. It’s her last chance to prove everything she can be—which is so much more than a show pony.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Scholastic\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0